import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

// Campaign Post API Types
export interface CampaignPostPayload {
  campaignId: string;
  postType: 'post_now' | 'scheduled';
  platforms: string[];
  restaurantId: string;
  startDate?: string;  // Only for scheduled
  endDate?: string;    // Only for scheduled
  /** What media the content being posted contains - used to tell TikTok whether to post as an image or a video */
  mediaType?: 'image' | 'video';
}

export interface CampaignPostResponse {
  success: boolean;
  message?: string;
  data?: any;
}

interface PostNowState {
  campaignPostLoading: boolean;
  campaignPostSuccess: boolean;
  campaignPostError: string | null;
  campaignPostData: any;
}

const initialState: PostNowState = {
  campaignPostLoading: false,
  campaignPostSuccess: false,
  campaignPostError: null,
  campaignPostData: null,
};

const postNowSlice = createSlice({
  name: 'postNow',
  initialState,
  reducers: {
    campaignPostRequest: (state, _action: PayloadAction<CampaignPostPayload>) => {
      state.campaignPostLoading = true;
      state.campaignPostSuccess = false;
      state.campaignPostError = null;
      state.campaignPostData = null;
    },
    campaignPostSuccess: (state, action: PayloadAction<CampaignPostResponse>) => {
      state.campaignPostLoading = false;
      state.campaignPostSuccess = true;
      state.campaignPostData = action.payload;
    },
    campaignPostFailure: (state, action: PayloadAction<string>) => {
      state.campaignPostLoading = false;
      state.campaignPostSuccess = false;
      state.campaignPostError = action.payload;
    },
    campaignPostReset: (state) => {
      state.campaignPostLoading = false;
      state.campaignPostSuccess = false;
      state.campaignPostError = null;
      state.campaignPostData = null;
    },
  },
});

export const {
  campaignPostRequest,
  campaignPostSuccess,
  campaignPostFailure,
  campaignPostReset,
} = postNowSlice.actions;

export default postNowSlice.reducer;
